import { Link } from "react-router-dom";
import { Brand } from "./Brand";
import { ContactButton } from "./ContactButton";
import { WhatsAppButton } from "./WhatsAppButton";
import { NAV_LINKS } from "@/lib/content";

export const Footer = () => (
  <footer className="border-t border-[#e4dacb] bg-[#f2ebe0]" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-9 px-5 py-14 sm:px-8 md:grid-cols-2 md:gap-10 md:py-16 lg:grid-cols-[0.9fr_0.6fr_1.4fr] lg:gap-12 lg:px-12">
      <div className="flex flex-col items-center gap-5 text-center md:items-start md:text-left">
        <Brand testId="footer-logo" />
        <p className="max-w-xs text-base leading-relaxed text-[#5d544c]">
          1:1 lifestyle coaching and a guided journey through the five layers of experience. Perceive, release, reconnect.
        </p>
      </div>
      <nav aria-label="Footer navigation" className="flex flex-col items-center gap-3 md:items-start">
        <span className="eyebrow">Pages</span>
        <div className="flex flex-wrap justify-center gap-x-3 md:flex-col md:items-start md:gap-1">
          {NAV_LINKS.map((link) => <Link key={link.to} to={link.to} data-testid={`footer-link-${link.id}`} className="inline-flex min-h-11 items-center rounded-sm px-3 text-base text-[#5d544c] hover:text-[#221e1b] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#7a5615] md:px-0">{link.label}</Link>)}
        </div>
      </nav>
      <div id="contact" className="flex scroll-mt-28 flex-col items-center gap-4 border-t border-[#e4dacb] pt-8 text-center md:col-span-2 md:items-start md:text-left lg:col-span-1 lg:border-t-0 lg:pt-0">
        <span className="eyebrow">Say hello</span>
        <p className="max-w-md text-base leading-relaxed text-[#5d544c]">Prefer an instant conversation? Reach out directly on WhatsApp to schedule a 1:1 discovery call.</p>
        <WhatsAppButton testId="footer-whatsapp-btn">Message Sheetal on WhatsApp</WhatsAppButton>
        <div className="my-2 h-px w-full bg-[#e4dacb]" />
        <p className="max-w-xs text-base leading-relaxed text-[#5d544c]">Leave your details and any questions. Sheetal will get back to you soon.</p>
        <ContactButton testId="footer-contact-btn" variant="outline" size="large" />
      </div>
    </div>
    <div className="mx-auto max-w-7xl border-t border-[#e4dacb] px-5 py-6 sm:px-8 lg:px-12">
      <p className="mb-4 text-center text-[13px] font-medium leading-relaxed text-[#5d544c] md:text-left" data-testid="site-licence">
        DED Trade Licence No. 1658046 · Dubai, UAE
      </p>
      <p className="text-xs leading-[1.5] text-[#666666]" data-testid="site-disclaimer">
        Disclaimer: Panchmaya Life Coaching provides non-clinical 1:1 lifestyle coaching and personal development coaching. All 1:1 coaching sessions, programs, and practices offered are strictly coaching-based, designed for self-exploration, habit building, active living, and personal growth. We do not provide medical advice, psychological therapy, diagnosis, or mental health treatment.
      </p>
      <p className="mt-5 text-center text-sm text-[#5d544c] md:text-left">© {new Date().getFullYear()} Panchmaya. All rights reserved.</p>
    </div>
  </footer>
);
